export default {
    data() {
        return {
            fullscreen: false,
            deleted_class: 'table-danger'
        };
    },
    computed: {
       
    },
    mounted() {
        
    },
    methods: {
        $can(permission) {
            return this.$page.props.auth.user.permissions.indexOf(permission) !== -1;
        },
        toggleMenuSidebar: function () {
            if (document.body.classList.contains('sidebar-open')) {
                document.body.classList.remove('sidebar-open')
                document.body.classList.add('sidebar-collapse')
            } else if (document.body.classList.contains('sidebar-collapse')) {
                document.body.classList.remove('sidebar-collapse')
                document.body.classList.add('sidebar-open')
            }
        },
        toggleMenu: function (el) {
            console.log('toggleMenu', el)
            el.target.closest('.nav-item').classList.toggle('menu-is-opening')
            el.target.closest('.nav-item').classList.toggle('menu-open')
        },
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
        fullscreenChange(fullscreen) {
            this.fullscreen = fullscreen
        },
        toggleFullscreen() {
            // this.$refs['fullscreen'].toggle()
            this.$fullscreen.toggle(document.body, { wrap: false })
        },
        sweetDelete: function (text, callback, data, options) {
            var defaults = {
                title: this.$t('front.areYouSure'),
                text: text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('front.yesDeleteIt'),
            };
            defaults = Object.assign({}, defaults, options || {});
            this.$swal(defaults).then(function (result) {
                if (result.isConfirmed && typeof callback === 'function') {
                    if (data) {
                        callback(data);
                    } else {
                        callback();
                    }
                }
            });
        },
        sweetError: function (text, callback, options) {
            var defaults = {
                icon: 'error',
                title: this.$t('front.error'),
                text: text,
                confirmButtonText: this.$t('front.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false
            };
            defaults = Object.assign({}, defaults, options || {});
            this.$swal(defaults).then(function (result) {
                typeof callback === 'function' && callback();
            });
        },
        sweetErrors: function (html, callback, options) {
            let defaults = {
                icon: 'error',
                title: this.$t('front.error'),
                html: html,
                confirmButtonText: this.$t('front.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false
            };
            defaults = Object.assign({}, defaults, options || {});
            this.$swal(defaults).then(function (result) {
                typeof callback === 'function' && callback();
            });
        },
        sweetInfo: function (text, callback, options) {
            var defaults = {
                icon: 'info',
                title: this.$t('front.information'),
                text: text,
                confirmButtonText: this.$t('front.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false,
            };
            defaults = Object.assign({}, defaults, options || {});
            this.$swal(defaults).then(function (result) {
                typeof callback === 'function' && callback();
            });
        },
        sweetSuccess: function (text, callback, options) {
            var defaults = {
                icon: 'success',
                title: this.$t('front.success'),
                text: text,
                timer: 2000,
                confirmButtonText: this.$t('front.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false,
            };
            defaults = Object.assign({}, defaults, options || {});
            this.$swal(defaults).then(function (result) {
                typeof callback === 'function' && callback();
            });
        },
    },
};
